import { render, staticRenderFns } from "./MaxSalaryExpectations.vue?vue&type=template&id=01ab6aae"
import script from "./MaxSalaryExpectations.vue?vue&type=script&lang=js"
export * from "./MaxSalaryExpectations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports